<template>
    <div v-if="is_read">
        <div class="wallet">
            <div class="wallet-title">alamat Tron saya</div>
            <input v-if="!is_bind" class="wallet-address" v-model="wallet_address" placeholder="Alamat Tron"/>
            <input v-else class="wallet-address" v-model="wallet_address" readonly/>
            <div v-if="!is_bind" class="pay-btn bg-color-blue" @click="bindWallet">untuk mengikat</div>
            <div v-else class="pay-btn bg-color-ddd">melompat</div>
        </div>
        <div class="teach">Belum punya Tron?<b @click="goPage">pergi unduh</b></div>
        <div class="teach">Sudah punya Tron, dimana alamatnya?<b @click="showContent">Klik untuk melihat</b></div>

        <div>
            <div class="title">{{title}}</div>
            <div class="content" id="content" v-html="content"></div>
        </div>
    </div>
</template>

<script>
    import {getHashTeach} from "../../api/trx"
    import {getUserBindTRX, userBindTRX} from "../../api/user"

    export default {
        name: "hash-wallet",
        data() {
            return {
                is_read: false,
                title: '',
                content: '',
                wallet_address: '',
                is_bind: false
            }
        },
        created() {
            this.getUserBindTRX()
        },
        methods: {
            goPage() {
                window.open('https://www.tronlink.org', '_blank');
            },
            getUserBindTRX() {
                let that = this
                getUserBindTRX().then(res => {
                    console.log(res)
                    if (res.length !== 0) {
                        that.wallet_address = res.data.tron_address
                        that.is_bind = res.data.is_bind === 1 ? true : false
                    }
                    this.is_read = true

                }).catch(res => {
                    this.$dialog.loading.close();
                    that.$dialog.toast({mes: res.msg})
                })
            },
            bindWallet() {
                if (this.wallet_address === '')
                    return this.$dialog.toast({mes: 'Alamat tidak boleh kosong'}) //地址不能为空
                let that = this
                userBindTRX({trx_address: this.wallet_address}).then(res => {
                    this.$dialog.loading.close();
                    that.$dialog.toast({mes: res.msg})
                }).catch(res => {
                    this.$dialog.loading.close();
                    that.$dialog.toast({mes: res.msg})
                })
            },
            showContent() {
                this.getTeach()
            },
            getTeach() {
                getHashTeach().then(res => {
                    this.title = res.data.title
                    this.content = res.data.content
                    console.log(res.data)
                }).catch(err => {
                    console.log(err)
                })
            },
        }
    }
</script>

<style scoped>
    .wallet {
        width: 100%;
        padding: .2rem;
        text-align: center;
    }

    .wallet-title {
        padding: .2rem;
        text-align: left;
    }

    .wallet-address {
        width: 95%;
        size: 1rem;
        padding: .2rem;
        border-radius: .1rem;
        border: 2px solid #ddd;
    }

    .bg-color-blue {
        color: #fff;
        margin: .3rem 2%;
        width: 96%;
        text-align: center;
        font-size: .4rem;
        padding: .1rem 0;
        border-radius: .1rem;
    }

    .bg-color-ddd {
        color: #fff;
        margin: .3rem 2%;
        width: 96%;
        text-align: center;
        font-size: .4rem;
        padding: .1rem 0;
        border-radius: .1rem;
        background: #ddd;
    }

    .teach {
        padding: 2px .2rem;
        text-align: right;
        font-size: .25rem;
        color: #778899;
    }

    .teach b {
        color: #00c3f9 !important
    }

    .title {
        text-align: center;
        margin-top: 1rem
    }

    .content {
        padding: 0 .1rem;
    }
</style>